export default {
  'modal': {
    'create': {
      'title': 'Création d\'un manager'
    }
  }
}



// WEBPACK FOOTER //
// ./src/translations/fr/manager.js